"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, COMMAND_PRIORITY_EDITOR } from 'lexical';
import { useEffect } from 'react';
import { EditorTagNode, $createEditorTagNode } from '../nodes/EditorTagNode.mjs';
import { INSERT_EDITOR_TAG_COMMAND } from './commands.mjs';

function EditorTagPlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!editor.hasNodes([EditorTagNode])) {
      throw new Error("EditorTagPlugin: EditorTagNode not registered on editor");
    }
    editor.registerCommand(
      INSERT_EDITOR_TAG_COMMAND,
      (payload) => {
        editor.update(() => {
          $insertNodes([$createEditorTagNode(payload)]);
        });
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);
  return null;
}

export { EditorTagPlugin };
